import { useEffect } from 'react'

export default function useNestedButtonWarningClickHandler() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // This handler checks if a devleoper has clicked on the warning message for a nested button.
      // The message is a pseudo-element, so it can't directly be assigned an onclick handler.
      // See src/client/styles/utils/nestedButtonWarningStyle.ts for the warning message implementation.
      function handleDevClick(event: MouseEvent) {
        const target = event.target as HTMLElement

        // Check if the target is a nested button element
        if (!target.matches('button button')) {
          return
        }

        // Get the button's bounding rectangle
        const buttonRect = target.getBoundingClientRect()
        const clickX = event.clientX

        // Check if the click is outside the button's actual area.
        // This implies that the developer has clicked the warning pseudo-element rather than the button itself.
        // (Unfortunately this can't be checked directly.)
        // The warning is positioned to the right, so only need to check that direction.
        const isOutsideButton = clickX > buttonRect.right

        if (isOutsideButton) {
          // Open documentation about nested button issues
          window.open('http://aussiecommerce.atlassian.net/wiki/spaces/TEC/pages/2412282650/Why+you+shouldn+t+put+a+button+in+a+button', '_blank')
          event.stopPropagation()
        }
      }
      window.addEventListener('click', handleDevClick, { capture: true })
      return () => window.removeEventListener('click', handleDevClick)
    }
  }, [])
}
